import { render, staticRenderFns } from "./UserChangeEmail.vue?vue&type=template&id=6faaa690&"
import script from "./UserChangeEmail.vue?vue&type=script&lang=js&"
export * from "./UserChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports